import request from '@/utils/request'
import baseUrl from '@/api/baseUrl'
import commonJs from '@/utils/common'
const BASE_URL = baseUrl +'/system' 

export default {
	/**
	 * 获取角色列表
	**/
	getRole(params){
		params = commonJs.obj.removeNullKey(params)
		return request({
			url: BASE_URL+'/role',
			method:'get',
			params
		})
	},

	/**
	 * 添加角色
	**/
    roleAdd(data) {
		return request({
		url: BASE_URL+'/role',
	    method: 'POST',
	    data
	  })
	},

	/**
	 * 修改角色
	**/
	roleEdit(id,data){
		return request({
			url: BASE_URL+'/role/'+id,
			method:'PUT',
			data
		})
	},
	/**
	 * 删除角色
	**/
	roleDel(id){
		return request({
			url: BASE_URL+'/role/'+id,
			method:'DELETE'
		})
	}
}